import React from "react";
export default function TechnicalCapabilities() {
  return (
    <div className="section borderLight">
      <h2>TechnicalCapabilities</h2>
      <p>Coming soon</p>
    </div>
  );
}
